let multiLang = {
    cn: {
        required: '此项为必填',
		phoneErr: '请正确填写手机号码',
		emailErr: '邮箱格式不正确',
        more: '更多',
        time: '时间',
        price: '价格',
        rateOfReturn: '回报率'
    },
    HK: {
        required: '此項為必填',
		phoneErr: '請正確填寫手機號碼',
		emailErr: '郵箱格式不正確',
        more: '更多',
        time: '時間',
        price: '價格',
        rateOfReturn: '回報率'
    },
	en: {
        required: 'This field is required',
		phoneErr: 'Please enter valid phone numbers',
		emailErr: 'E-mail format is incorrect',
        more: "More",
        time: 'Time',
        price: 'Price',
        rateOfReturn: 'Rate of return'
    }
}

export default function Language() {
    // const langCode = document.getElementById('lang').value;
    
    const langCode = document.documentElement.getAttribute('lang');

    let lang = multiLang[langCode];
    
    return lang;
}